export interface Song {
  id: string
  title: string
  year: string
  duration: string
  image: string
  trackNumber: string
  spotifyUrl?: string
  appleMusicUrl?: string
  youtubeUrl?: string
}

export const SONGS: Song[] = [
  {
    id: '1',
    title: 'deja vu',
    year: '2023',
    duration: '3:42',
    trackNumber: '20',
    image: 'https://i.scdn.co/image/ab67616d00001e0203f537e57834874fb6dd2e68',
  },
  {
    id: '2',
    title: 'UPSTATE',
    year: '2023',
    duration: '4:15',
    trackNumber: '19',
    image: 'https://i.scdn.co/image/ab67616d00001e02a4840fb2f9e6e38434924b9c',
  },
  {
    id: '3',
    title: 'MANSON',
    year: '2024',
    duration: '2:58',
    trackNumber: '18',
    image: 'https://i.scdn.co/image/ab67616d00001e0259c53eca20aa02802f276411',
  },
  {
    id: '4',
    title: 'HOLLOW TIPS',
    year: '2024',
    duration: '5:01',
    trackNumber: '17',
    image: 'https://i.scdn.co/image/ab67616d00001e021aa0bb535714c9a311b5222a',
  },
  {
    id: '5',
    title: '2:23 AM',
    year: '2024',
    duration: '3:22',
    trackNumber: '16',
    image: 'https://i.scdn.co/image/ab67616d00001e029a5391b39de81b2c4de1d5b6',
  },
  {
    id: '6',
    title: 'SEASIDE',
    year: '2025',
    duration: '4:40',
    trackNumber: '15',
    image: 'https://i.scdn.co/image/ab67616d00001e02b706162d9a60ccbedfed0fc8',
  },
  {
    id: '7',
    title: 'PLASTIC',
    year: '2025',
    duration: '3:15',
    trackNumber: '14',
    image: 'https://i.scdn.co/image/ab67616d00001e02aecbb72f8f7c68a64de0f5c8',
  },
  {
    id: '8',
    title: 'GOOD TIMES',
    year: '2025',
    duration: '4:02',
    trackNumber: '13',
    image: 'https://i.scdn.co/image/ab67616d00001e0254ebb92cbbdad3aee43414f7',
  },
  {
    id: '9',
    title: 'ONE LIFE',
    year: '2025',
    duration: '3:45',
    trackNumber: '12',
    image: 'https://i.scdn.co/image/ab67616d00001e02dbd0a59a9d4ae4ca3c33cc5e',
  },
  {
    id: '10',
    title: 'YOU ONLY LIVE FOREVER EP',
    year: '2025',
    duration: '2:50',
    trackNumber: '11',
    image: 'https://i.scdn.co/image/ab67616d00001e0289287ba45a9d1e470e4ce0c8',
  },
  {
    id: '11',
    title: 'YOU ONLY LIVE FOREVER (B SIDE)',
    year: '2025',
    duration: '3:10',
    trackNumber: '10',
    image: 'https://i.scdn.co/image/ab67616d00001e0264f96d9d296113cfb9790061',
  },
  {
    id: '12',
    title: 'DEADBEAT',
    year: '2025',
    duration: '4:20',
    trackNumber: '09',
    image: 'https://i.scdn.co/image/ab67616d00001e02d381cfd5a6f95c99731a4f0b',
  },
  {
    id: '13',
    title: 'KIDS WITH DRUGS',
    year: '2025',
    duration: '3:33',
    trackNumber: '08',
    image: 'https://i.scdn.co/image/ab67616d00001e0240a3777ed2009cbf0d37c86c',
  },
  {
    id: '14',
    title: 'I LIKE IT',
    year: '2025',
    duration: '2:45',
    trackNumber: '07',
    image: 'https://i.scdn.co/image/ab67616d00001e026ad77fc566edef6a72d672d2',
  },
  {
    id: '15',
    title: 'SCUMF*CK!',
    year: '2025',
    duration: '3:20',
    trackNumber: '06',
    image: 'https://i.scdn.co/image/ab67616d00001e02dcabd680848bafbdb9f35ead',
  },
  {
    id: '16',
    title: 'SPINNING',
    year: '2025',
    duration: '4:12',
    trackNumber: '05',
    image: 'https://i.scdn.co/image/ab67616d00001e02e657039142351893fb7a98f3',
  },
  {
    id: '17',
    title: 'REMATCH',
    year: '2025',
    duration: '3:50',
    trackNumber: '04',
    image: 'https://i.scdn.co/image/ab67616d00001e022b982b54d23fc26f3cb8f3bd',
  },
  {
    id: '18',
    title: 'MATRIX',
    year: '2025',
    duration: '3:40',
    trackNumber: '03',
    image: 'https://i.scdn.co/image/ab67616d00001e02613b0ac80e2b85ebddea85e8',
  },
  {
    id: '19',
    title: 'OVERDRIVE',
    year: '2025',
    duration: '4:05',
    trackNumber: '02',
    image: 'https://i.scdn.co/image/ab67616d00001e02abdb08bd2650548112448bb6',
  },
  {
    id: '20',
    title: 'SHOW PONY',
    year: '2025',
    duration: '3:18',
    trackNumber: '01',
    image: 'https://i.scdn.co/image/ab67616d00001e02e1abc1f4ae879ada2d00844d',
    spotifyUrl:
      'https://open.spotify.com/track/5PtBrwL6W6vszW1tZrLuOL?si=99624c0f37254039',
    appleMusicUrl:
      'https://music.apple.com/us/album/show-pony/1895298811?i=6763404067',
  },
]
